import React, { useEffect } from "react";
import "../../global.scss";

import PersonalDetails from "../OnBoarding/PersonalDetails";
import Header from "../../utils/Header";
import {
	IonGrid,
	IonRow,
	IonCol,
	IonText,
	IonButton,
	IonLabel,
	IonSlide,
	IonSlides,
	IonSpinner,
	IonModal,
	isPlatform,
} from "@ionic/react";

import "./dashboard.scss";
import CarsSlides from "./CarsSlides";
import { DisCountSliders } from "./DiscountSliders";
import RecommendedService from "./RecommendedService";

import {
	MY_DASHBOARD,
	SERVICE_STATUS,
	YOU_DONT_HAVE_ACTIVE_SERVICES,
	BOOK_A_SERVICE,
	OVER_2K_PLUS,
	LAST_SERVICE,
	ODOMETER,
	NEXT_SERVICE,
	DEFAULT,
	NO_ACTIVE_SERVICES_AVAILABLE,
	SELECT_YOUR_ADDRESS,
	CURRENT_LOCATION,
	USING_GPS,
	ADD_NEW_ADDRESS,
	RupeeSymbol,
	PAYMENT_PENDING,
	UPDATE,
	CLIENT_NAME,
} from "../../constants";
import { connect } from "react-redux";
import {
	// getModelsData,
	getRecommendedServices,
	storeCarSlidesData,
	userAddress,
	getOffersData,
	saveCatelogVehicleId,
	setSelectedVehicle,
	getArticlesData,
	saveAddressRef,
	saveWorkshopStandard,
	addItemToCart,
	getCartItemsList,
	bookingSummary,
	updateParticularBookingDetails,
	updateReservationParticularBookingDetails,
	getAdvancePaymentOrderId,
	razorpayCallBack,
} from "../../Store/Actions";

import { Plugins } from "@capacitor/core";
import { usePosition } from "../../utils/usePosition";
import { COLLECTIONS } from "../../firebase";
import Geocode from "react-geocode";
import UserAddressModal from "../../utils/UserAddressModal";
import MyBookingsStatusCard from "./Booking/MyBookingsStatusCard";
import { checkMediaQuery } from "../../utils";
import { ToastMessage } from "../../utils/toastMessage";
import moment from "moment";
import BookingDetailsBanner from "./Booking/BookingsDetBanner";
import { AppVersion } from "@ionic-native/app-version";
import compareVersions from "compare-versions";
import { intializeIntercom } from "../../intercom";

const Dashboard: React.FC = (props: any) => {
	const [state, setState] = React.useState(Boolean);
	const [initialSlide, setIntialSide] = React.useState(0);
	const [showAddModal, setShowAddModal] = React.useState(false);
	const [showReschedulePopUp, setReschedulePopUp] = React.useState(false);
	const [activeBookings, setActiveBooking] = React.useState([]) as any;
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	const [paymentSuccess, setPaymentSuccess] = React.useState("");
	const [showPaymentPendingCard, setShowPaymentPendingCard] = React.useState(false);
	const [showForceUpdateModal, setForceUpdateModal] = React.useState(false);
	const { particularBookingDetails } = props;
	const [selectedCatelogVehicleId, setSelectedCatelogVehicleId] = React.useState("");

	useEffect(() => {
		if (!!props.globalSettings.length) {
			AppVersion.getVersionNumber()
				.then((version) => {
					const versionComp = compareVersions(
						props.globalSettings[0].minAppVersion,
						version
					);
					if (versionComp > 0) {
						setForceUpdateModal(true);
					} else {
						setForceUpdateModal(false);
					}
				})
				.catch((error) => {
					console.error(error);
				});
		}
	}, [props.globalSettings]);

	useEffect(() => {
		fetchData();
		// console.log("110 ====== ", props);
	}, [props.userVehiclesList]);

	useEffect(() => {
		props.getArticlesData({ articleListId: "default", clientName: CLIENT_NAME });
	}, [(props.articleData || []).length]);

	useEffect(() => {
		// fetchOffersAndArticles();
		// console.log("120 ======", selectedCatelogVehicleId);
		if (!!props.sliderCatelogVehicleId) {
			const vid = (
				props.userVehiclesList.find(
					(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
				) || {}
			).did;
		}
	}, [props.sliderCatelogVehicleId]);

	React.useEffect(() => {
		if (!!props.sliderCatelogVehicleId) {
			if (props.userVehiclesList.length) {
				const a = props.userVehiclesList.findIndex(
					(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
				);
				setIntialSide(a);
			}
		}
		if (props.bookingList.length && !!props.sliderCatelogVehicleId) {
			setActiveBooking(
				props.bookingList.filter((ele: any) => {
					if (
						ele.userVehicleId === props.sliderCatelogVehicleId &&
						ele.status === "InProgress"
					)
						return ele;
				})
			);
			props.updateParticularBookingDetails(
				props.bookingList.filter((ele: any) => {
					if (
						ele.userVehicleId === props.sliderCatelogVehicleId &&
						ele.status === "InProgress"
					)
						return ele;
				})
			);
			props.updateReservationParticularBookingDetails(
				props.bookingList.filter((ele: any) => {
					if (
						ele.userVehicleId === props.sliderCatelogVehicleId &&
						ele.status === "InProgress"
					)
						return ele;
				})
			);
		}

		// console.log("Setting VID ====", props);
		// props.setSelectedVehicle(
		//   `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/SJGI5CL9gUrqpXrgus3C}`,
		// );
	}, [props.sliderCatelogVehicleId, props.bookingList]);

	useEffect(() => {
		handlePaymentCard();
		setSelectedCatelogVehicleId(props.sliderCatelogVehicleId);

		const vRegNo = (
			props.userVehiclesList.find(
				(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
			) || {}
		).registrationNumber;

		const wsId = (
			props.userVehiclesList.find(
				(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
			) || {}
		).registrationNumber;

		// console.log("vRegNo ===....... ==== ", vRegNo);
		// console.log("CHK workshopId ========================", props);

		if (!!vRegNo) {
			props.bookingSummary({
				registrationNumber: vRegNo,
			});
		}
	}, [particularBookingDetails]);

	const handlePaymentCard = () => {
		if (!!particularBookingDetails.length && !!particularBookingDetails[0].events) {
			const paymentPendingIndex = (particularBookingDetails[0].events || []).findIndex(
				(item: any, ind: any) => item.name === "Payment Pending"
			);
			if (
				paymentPendingIndex &&
				!!particularBookingDetails[0].events[paymentPendingIndex - 1].updatedAt &&
				!particularBookingDetails[0].events[paymentPendingIndex].updatedAt
			) {
				setShowPaymentPendingCard(true);
			} else {
				setShowPaymentPendingCard(false);
			}
		}
	};

	const fetchData = async () => {
		// if (props.userVehiclesList.length) {
		//   const data: any = props.userVehiclesList[0].catalogVehicleId;
		//   props.getRecommendedServices({
		//     catalogVehicleId: data,
		//   });
		//   await props.saveCatelogVehicleId(data);
		// }

		// console.log("230 ===========", props);

		const vDid = (
			props.userVehiclesList.find(
				(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
			) || {}
		).did;

		// particularBookingDetails

		// console.log("V DID  ====", vDid);
		// console.log("SVR == ", `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${vDid}`);

		await Promise.all([
			props.userVehiclesList.length &&
				props.setSelectedVehicle(
					`${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${vDid}` //props.userVehiclesList[0].did}`,
				),
		]);
	};

	const getIndex = async (event: any) => {
		await event.target.getActiveIndex().then(async (value: any) => {
			if (
				props.userVehiclesList.length &&
				!!(props.userVehiclesList[value] || {}).catalogVehicleId
			) {
				// console.log("Get Address ====", props);
				const addressDetails = (props.userAddressList || []).find(
					(ele: any) => ele.did === props.selectedAddressRef
				);

				let workshopId: any = "";

				if (!!props.location) {
					if (!!props.location.state) {
						if (!!props.location.state.workshopId) {
							workshopId = props.location.state.workshopId;
						}
					}
				}

				if (workshopId === "") {
					if (localStorage.getItem("workshopId")) {
						workshopId = localStorage.getItem("workshopId");
					}
				}

				if (!!addressDetails) {
					await props.getRecommendedServices({
						catalogVehicleId: props.userVehiclesList[value].catalogVehicleId,
						latitude: addressDetails.latitude,
						longitude: addressDetails.longitude,
						workshopId: workshopId,
						clientName: CLIENT_NAME,
						make: props.userVehiclesList[value].make,
					});
				}

				await props.saveCatelogVehicleId(props.userVehiclesList[value].catalogVehicleId);
				await props.setSelectedVehicle(
					`${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${props.userVehiclesList[value].did}`
				);
			}
		});
	};

	const vehicleOdo = (
		props.userVehiclesList.find(
			(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
		) || {}
	).odometer;

	const getInitialSlide = (slideId: any) => {
		// console.log("GET INITIAL SLIDE =======");
		if (!!slideId) {
			if (props.userVehiclesList.length) {
				const a = props.userVehiclesList.findIndex(
					(ele: any) => ele.catalogVehicleId === slideId
				);
				return a;
			}
		}
		return 0;
	};

	const mergeAlernatively = (array1: any, array2: any) => {
		const len = Math.max(array1.length, array2.length);
		const result = [];
		for (let i = 0; i < len; i++) {
			if (array1[i] !== undefined) {
				result.push(array1[i]);
			}
			if (array2[i] !== undefined) {
				result.push(array2[i]);
			}
		}
		return result;
	};
	const carResponsive = [
		{
			image: "/images/carSlide1.svg",
			model: "Add New Vehicle",
			data: "Choose from 3000+ models",
			service: "Next Schedule",
		},
	];

	const getUserCurrentLocation = () => {
		navigator.geolocation.getCurrentPosition(
			(resp) => {
				const { coords } = resp;
				const { latitude, longitude } = coords;
				props.storeCurrentLatLong(latitude, longitude);
				Geocode.fromLatLng(latitude, longitude).then(
					(response: any) => {
						const address = response.results[0].formatted_address;
						props.storeUserMapAddress(address);
					},
					(error: any) => {
						console.error(error, "error");
					}
				);
			},
			(e: any) => console.error(e, "e")
		);
	};

	const PaymentPending = {
		statusImg: "/images/PaymentPending.svg",
		statusLabel: PAYMENT_PENDING,
		statusSummary1: `Please Complete the payment of ${RupeeSymbol}${
			!!particularBookingDetails.length
				? Number(particularBookingDetails[0].estimate.totalEstimated) -
				  Number(particularBookingDetails[0].estimate.discount) -
				  Number(particularBookingDetails[0].estimate.advancePayment)
				: ""
		}`,
		statusSummary2: `on your Booking : ${
			!!particularBookingDetails.length ? particularBookingDetails[0].bookingCode : ""
		}`,
		banerColor: "#FF7D2F",
	};

	const PaymentSuccessful = {
		statusImg: "/images/bookingConfirmed.svg",
		statusLabel: "Payment Successful",
		statusSummary1: `Your payment of ${RupeeSymbol}${
			!!particularBookingDetails.length
				? Number(particularBookingDetails[0].estimate.totalEstimated) -
				  Number(particularBookingDetails[0].estimate.discount) -
				  Number(particularBookingDetails[0].estimate.advancePayment)
				: ""
		} on your `,
		statusSummary2: `Booking : ${
			!!particularBookingDetails.length ? particularBookingDetails[0].bookingCode : ""
		} is Successful`,
		banerColor: "var(--ion-color-lightgreen)",
	};

	const PaymentFailed = {
		statusImg: "/images/bookingCancelled.svg",
		statusLabel: "Payment Failed",
		statusSummary1: `Any deducted amount will be refunded back, Please`,
		statusSummary2: `contact us or try again`,
		banerColor: "var(--ion-color-darkpink)",
	};

	const PaymentCancelled = {
		statusImg: "/images/bookingCancelled.svg",
		statusLabel: "Payment Cancelled",
		statusSummary1: `You Have Cancelled Payment`,
		statusSummary2: `contact us or try again`,
		banerColor: "var(--ion-color-darkpink)",
	};

	const combinedArray = mergeAlernatively(props.offersData, props.articlesData);
	return (
		<IonCol className="middle_panle res_bg_color pd_0" size-md="6">
			<IonGrid className="dashboard pd_0">
				<IonRow className="pd_0">
					<IonCol className="user-location-mobile pd_0">
						<UserAddressModal {...props} />
					</IonCol>
					{!checkMediaQuery() && (
						<IonCol className="webscreen pd_0 dashboard_slide">
							<IonText className="header_text">{MY_DASHBOARD}</IonText>
							<div className="my_dashboard empty_dashboard">
								{/* <IonRow className="flat_discount"> */}
								<CarsSlides {...props} />
								{/* </IonRow> */}
							</div>
						</IonCol>
					)}
					{checkMediaQuery() && Boolean(props.userVehiclesList.length) ? (
						<IonCol className="responsive_screen p-0" size="12">
							<IonRow className="flat_discount">
								<IonSlides
									pager={false}
									options={{
										initialSlide:
											getInitialSlide(props.sliderCatelogVehicleId) < 0
												? 0
												: getInitialSlide(props.sliderCatelogVehicleId),
										loop: false,
										autoplay: false,
										spaceBetween: 15,
									}}
									onIonSlidesDidLoad={(event: any) => {
										// event.target.slideTo(initialSlide);
										getIndex(event);
									}}
									onIonSlideWillChange={(event: any) => getIndex(event)}
									key={props.userVehiclesList.map((ele: any) => ele.did).join(",")}
								>
									{props.userVehiclesList.map((ele: any, ind: any) => (
										<IonSlide key={ind} className={"ion-slide-mobile"}>
											<div
												className={
													ind % 2 === 0
														? "manage_vehicle_body car-slides-mobile"
														: "manage_vehicle_body car-slides-next-index"
												}
												style={{
													alignSelf: "flex-end",
												}}
											>
												<div className="manage_vehicle">
													<img src={ele.imageUrl} className="manage_vehicle_img" />
												</div>
												<div className="brand_data">
													<IonLabel className="brand_text" color="light">
														{ele.make} {ele.model}
														<img
															className="dropdown_img"
															src="/images/dropdown_icon_res.svg"
															onClick={() =>
																props.history.push(
																	`/portal/manage-your-vehicle/${ele.did}`
																)
															}
														/>
													</IonLabel>
													<IonLabel className="brand_year" color="light">
														{ele.year}, {ele.fuelType}
													</IonLabel>
												</div>
												{ele.did === (props.defaultVehicleRef || "").split("/").pop() && (
													<div className="default">
														<IonLabel className="default_text" color="light">
															{DEFAULT}
														</IonLabel>
													</div>
												)}
											</div>
										</IonSlide>
									))}
								</IonSlides>
							</IonRow>
						</IonCol>
					) : (
						<IonCol className="responsive_screen p-0" size="12">
							<IonSlides
								onClick={() => props.history.push("/portal/add-vehicles")}
								pager={false}
								options={{
									loop: false,
									autoplay: false,
									scrollbar: false,
								}}
							>
								{carResponsive.map((ele: any, ind: any) => (
									<IonSlide key={ind} className="ion-slide-mobile-no-vehicles">
										<div className="manage_vehicle_body no-vehicle-slide">
											<div className="manage_vehicle">
												<img src={ele.image} className="manage_vehicle_img" />
											</div>
											<div className="brand_data">
												<IonLabel className="brand_text" color="light">
													{ele.model}
												</IonLabel>
												<IonLabel className="brand_year" color="light">
													{ele.data}
												</IonLabel>
											</div>
											<div className="add_image">
												<img src="/images/empty_vehicle.svg" />
											</div>
										</div>
									</IonSlide>
								))}
							</IonSlides>
						</IonCol>
					)}
					<IonCol className="server_status pd_0">
						<IonText className="header_text webscreen service_text">
							{" "}
							{SERVICE_STATUS}
						</IonText>

						{!(activeBookings || []).length ? (
							<div className="my_service_status webscreen">
								<IonText className="active_service">
									{YOU_DONT_HAVE_ACTIVE_SERVICES}
								</IonText>
								<div>
									<IonButton
										color="primary"
										className="book_btn"
										expand="block"
										onClick={() => props.history.push("/portal/book_service")}
									>
										{BOOK_A_SERVICE}
									</IonButton>
								</div>
								<IonText className="over_2k">{OVER_2K_PLUS}</IonText>
							</div>
						) : showPaymentPendingCard ? (
							<div className="statusCard_container">
								<BookingDetailsBanner
									{...props}
									statusImg="/images/bookingConfirmed.svg"
									bookingId={!!activeBookings.length ? activeBookings[0].bookingCode : ""}
									bookingStatus={
										paymentSuccess === "success"
											? PaymentSuccessful
											: paymentSuccess === "failed"
											? PaymentFailed
											: paymentSuccess === "cancelled"
											? PaymentCancelled
											: PaymentPending
									}
									paymentCb={(val: any) => setPaymentSuccess(val)}
									fromDashboard={true}
								/>
							</div>
						) : (
							<div className="statusCard_container">
								{activeBookings.map((ele: any, ind: any) => (
									<MyBookingsStatusCard
										{...props}
										{...ele}
										setModalValue={(val: any) => setReschedulePopUp(val)}
										modalOpenValue={showReschedulePopUp}
										uiChangeReq={true}
										key={ind}
									/>
								))}
							</div>
						)}
						<IonRow className="serveice_body pd_0">
							<IonCol className="service_details mg-left_15">
								<div className="services_parent_div">
									<img className="service_imgs" src="/images/last_service.svg" />
									<IonLabel className="services_text">
										<IonText className="car-details-text-color">{LAST_SERVICE}</IonText>
										<IonText className="dotter_lines">
											{!!(props.bookingSummaryDetails || []).length &&
											!!props.bookingSummaryDetails[0].lastServiceDate ? (
												<>
													{moment(props.bookingSummaryDetails[0].lastServiceDate).format(
														"DD MMM"
													)}
													{isPlatform("desktop") &&
														moment(props.bookingSummaryDetails[0].lastServiceDate).format(
															", YYYY"
														)}
												</>
											) : (
												"-- ---"
											)}
										</IonText>
									</IonLabel>
								</div>
							</IonCol>
							<IonCol className="service_details mg-left_19">
								<div className="services_parent_div">
									<img className="service_imgs" src="/images/next_service.svg" />
									<IonText className="services_text">
										<IonText className="car-details-text-color">{NEXT_SERVICE}</IonText>
										<IonText className="dotter_lines">
											{!!(props.bookingSummaryDetails || []).length &&
											!!props.bookingSummaryDetails[0].nextServiceDate ? (
												<>
													{moment(props.bookingSummaryDetails[0].nextServiceDate).format(
														"DD MMM"
													)}
													{isPlatform("desktop") &&
														moment(props.bookingSummaryDetails[0].nextServiceDate).format(
															", YYYY"
														)}
												</>
											) : (
												"-- ---"
											)}
										</IonText>
									</IonText>
								</div>
							</IonCol>
							<IonCol
								className="service_details mg-left_19"
								style={{ marginRight: "0px" }}
							>
								<div className="services_parent_div">
									<img className="service_imgs" src="/images/odomenter.svg" />
									<div className="services_text">
										<IonText className="car-details-text-color">{ODOMETER}</IonText>
										<IonText className="dotter_lines">
											{" "}
											{/* {props.userVehiclesList.length && !!vehicleOdo
                        ? vehicleOdo > 999
                          ? Math.abs(vehicleOdo / 1000).toFixed(2) + "K"
                          : vehicleOdo
                        : "-----"} */}
											{props.userVehiclesList.length && !!vehicleOdo
												? vehicleOdo
												: "-----"}
											<img
												className="pencil_image webscreen"
												src="/images/pencil.svg"
												onClick={() => {
													if (!!props.selectedVehicleRef) {
														props.history.push(
															`/portal/manage-your-vehicle/${props.selectedVehicleRef
																.split("/")
																.pop()}`
														);
													} else {
														setToast({
															showToast: true,
															toastMessage: "Please add vehicle",
															severity: "warning",
														});
													}
												}}
											/>
										</IonText>
										{/* <div>
                      <IonLabel className="odomter-value"></IonLabel>
                      <img
                        className="pencil_image webscreen"
                        src="/images/pencil.svg"
                      />
                    </div> */}
									</div>
								</div>
							</IonCol>
						</IonRow>
					</IonCol>
					<IonCol className="responsive_screen p-0" size="12" size-sm size-md="9">
						{!(activeBookings || []).length ? (
							<div
								className="book_serivice_res"
								onClick={() => props.history.push("/portal/book_service")}
							>
								<IonLabel className="book_service_text" color="primary">
									{BOOK_A_SERVICE}
									<p className="no_services">{NO_ACTIVE_SERVICES_AVAILABLE}</p>
								</IonLabel>
								<img className="right_arrow" src="/images/book_service.svg" />
							</div>
						) : showPaymentPendingCard ? (
							<div className="mobileStatusCard">
								<BookingDetailsBanner
									{...props}
									statusImg="/images/bookingConfirmed.svg"
									bookingId={!!activeBookings.length ? activeBookings[0].bookingCode : ""}
									bookingStatus={
										paymentSuccess === "success"
											? PaymentSuccessful
											: paymentSuccess === "failed"
											? PaymentFailed
											: paymentSuccess === "cancelled"
											? PaymentCancelled
											: PaymentPending
									}
									paymentCb={(val: any) => setPaymentSuccess(val)}
									fromDashboard={true}
								/>
							</div>
						) : (
							<div className="mobileStatusCard">
								{activeBookings.map((ele: any, ind: any) => (
									<MyBookingsStatusCard
										{...props}
										{...ele}
										setModalValue={(val: any) => setReschedulePopUp(val)}
										modalOpenValue={showReschedulePopUp}
										uiChangeReq={true}
										key={ind}
									/>
								))}
							</div>
						)}
					</IonCol>
				</IonRow>
				{Boolean(combinedArray.length) && (
					<IonRow className="flat_discount">
						<DisCountSliders {...props} flatDisCountSlides={combinedArray} />
					</IonRow>
				)}
				<IonRow
					className={!!combinedArray.length ? "recommende_service" : "service_margin_top"}
				>
					<RecommendedService {...props} />
				</IonRow>
			</IonGrid>
			<IonModal isOpen={showAddModal} backdropDismiss={false}>
				<div className="modal_body">
					<div className="modal_panel">
						<IonText className="modal_header">{SELECT_YOUR_ADDRESS}</IonText>
						<img
							className="close_icon"
							onClick={() => setShowAddModal(false)}
							src="/images/close_popup.svg"
						/>
					</div>
					<div className="loc_pointer_par modal_margin_30">
						<img src="/images/green_cur_loc.svg" className="loc_pointer" />
						<div className="cur_loc_text_par">
							<IonLabel
								className="cur_loc_text"
								onClick={() => {
									getUserCurrentLocation();
									props.history.push("/portal/add-new-address");
									setShowAddModal(false);
								}}
							>
								{CURRENT_LOCATION}
							</IonLabel>
							<IonLabel className="using_gps_text">{USING_GPS}</IonLabel>
						</div>
					</div>
					<div className="address-wrapper">
						{(props.userAddressList || []).map((ele: any, index: any) => (
							<div
								key={index}
								className="address-pill additional_pill_style modal_margin_30"
								onClick={() => {
									props.saveAddressRef(ele.did);
									setShowAddModal(false);
								}}
							>
								<div
									className={
										(props.defaultAddressRef || "").split("/").pop() === ele.did
											? "defadd-container"
											: "defadd-container-empty"
									}
								>
									{(props.defaultAddressRef || "").split("/").pop() === ele.did && (
										<IonLabel className="defadd-text">{""}</IonLabel>
									)}
								</div>
								<div className="default_label_parent">
									<IonLabel className="address-type">{ele.addressType}</IonLabel>
									{(props.defaultAddressRef || "").split("/").pop() === ele.did && (
										<div className="bg_color_label">
											<IonLabel
												style={{
													color: "#38c172",
													fontSize: 8,
													fontWeight: 800,
												}}
											>
												{DEFAULT}
											</IonLabel>
										</div>
									)}
								</div>
								<IonLabel className="address-fulladd">
									{ele.addressline1}
									{", "}
									{ele.landmark}
									{", "}
									{ele.city}
									{", "}
									{ele.postalCode}
									{", "}
									{ele.country}
								</IonLabel>
							</div>
						))}
					</div>
					<div
						className="btn_parent_div mg-top_90"
						onClick={() => {
							setShowAddModal(false);
							props.history.push("/portal/add-new-address");
						}}
					>
						<IonButton color="customgreen" className="continue_btn child_btn ">
							<IonLabel style={{ color: "white" }}>{ADD_NEW_ADDRESS}</IonLabel>
						</IonButton>
					</div>
				</div>
			</IonModal>
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
			<IonModal
				isOpen={showForceUpdateModal}
				// isOpen={true}
				backdropDismiss={false}
				cssClass={"modalRoot"}
				onDidDismiss={() => console.log("Dismiss")}
			>
				<div className="changeVehRoot fa_cont">
					<div className="fa_rowcenter">
						<img src="/images/autoUpdate.svg" className="fa_img" />
						<IonLabel className="changeVehicle" style={{ margin: 0 }}>
							"TSERV" needs to be updated
						</IonLabel>
					</div>
					<IonLabel className="changeVehCon fa_fs14" style={{ marginTop: 20 }}>
						A new version of this application is available.
					</IonLabel>
					<IonLabel className="changeVehCon fa_fs14">
						Inorder to continue, you must update the
					</IonLabel>
					<IonLabel className="changeVehCon fa_fs14">application now.</IonLabel>

					<IonButton
						fill="solid"
						className="conbtns fa_conbtns"
						onClick={async () => {
							// console.log("Go to app link");
						}}
					>
						<IonLabel className="modalNo" style={{ color: "white" }}>
							{UPDATE}
						</IonLabel>
					</IonButton>
				</div>
			</IonModal>
		</IonCol>
	);
};

export default connect(
	({
		auth,
		userInfo: {
			userAddress,
			searchRecommendations,
			userVehiclesList,
			carSlidesData,
			sliderCatelogVehicleId,
			userAddressList,
			selectedAddressRef,
		},
		addVehicles: { modelsData },
		dashboard: { offersData, articlesData },
		cart: { service_data },
		booking,
		workshop: { globalSettings },
	}: any) => {
		return {
			...auth,
			...booking,
			userAddress,
			userAddressList,
			sliderCatelogVehicleId,
			searchRecommendations,
			userVehiclesList,
			modelsData,
			offersData,
			carSlidesData,
			articlesData,
			selectedAddressRef,
			service_data,
			globalSettings,
		};
	},
	{
		userAddress,
		saveAddressRef,
		getRecommendedServices,
		// getModelsData,
		storeCarSlidesData,
		getOffersData,
		saveCatelogVehicleId,
		setSelectedVehicle,
		getArticlesData,
		saveWorkshopStandard,
		addItemToCart,
		getCartItemsList,
		bookingSummary,
		updateParticularBookingDetails,
		updateReservationParticularBookingDetails,
		getAdvancePaymentOrderId,
		razorpayCallBack,
	}
)(Dashboard);
